module.exports = __webpack_public_path__ + "static/media/project-region-left.e77fb0ed.jpg";